/**
 * Created by fers on 25.07.16.
 */

/**
 * Parse query parameters.
 *
 * @param qs
 * @returns {{}}
 */
export function getQueryParams(qs) {
    qs = qs.split('?');
    qs = qs[qs.length - 1];
    qs = qs.split('+').join(' ');

    let params = {};
    let tokens;
    let re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) { // eslint-disable-line no-cond-assign
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
}
